import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { ApiCallService } from './api-call.service';
import { Showcase } from '../models/index';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class ShowcaseService extends BaseApiService implements Resolve<Showcase> {
  constructor(
    private apiCallService: ApiCallService,
  ) {
    super();
  }

  getShowcase(agencyUuid: string, uuid: string): Promise<Showcase> {
    this.apiCallService.agencyUuid = agencyUuid;
    return this.apiCallService.get('/showcases/' + uuid);
  }

  requestDetails(agencyUuid: string, uuid: string): Promise<Showcase> {
    this.apiCallService.agencyUuid = agencyUuid;
    return this.apiCallService.post(`/showcases/${uuid}/request_details`, null);
  }

  logLinkOpened(agencyUuid: string, uuid: string): Promise<Showcase> {
    this.apiCallService.agencyUuid = agencyUuid;
    return this.apiCallService.get(`/showcases/${uuid}/link_opened`);
  }

  resolve(route: ActivatedRouteSnapshot): Promise<Showcase> {
    if (route.queryParams['utm_source'] === 'vaunt') {
      this.logLinkOpened(route.params['agency_uuid'], route.params['uuid'])
    }

    const promise = this.getShowcase(
      route.params['agency_uuid'],
      route.params['uuid']
    ).catch((error) => {
      throw error;
    });

    return promise;
  }
}
